// Configure lazysizes: 1200px on desktop, 500px on mobile
window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.expand = window.innerWidth > 768 ? 1200 : 500;

import 'lazysizes';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import 'lazysizes/plugins/video-embed/ls.video-embed';
import Alpine from 'alpinejs';

window.Alpine = Alpine;

Alpine.start();

import '@/scripts/utils/imagewind';
import '@/scripts/utils/gtm';
import '@/scripts/utils/superscript';
import '@/scripts/components/autoplay';
import '@/scripts/components/cart';
import '@/scripts/components/doc-height';
import '@/scripts/components/image-carousel';
import '@/scripts/components/modal';
import '@/scripts/components/one-page-nav';
import '@/scripts/components/product';
import '@/scripts/components/smooth';
import '@/scripts/components/textarea';
import '@/scripts/components/waitlist';
import '@/scripts/components/size-table';

// Leave as last one
import '@/styles/app.css';

import '@/vue/init';